// Dev-only error logger. In production CRA does dead-code elimination on
// `process.env.NODE_ENV !== "production"` so console.error calls are stripped
// from the final bundle. Keeps our silent-catch paths debuggable in dev
// without exposing anything to end users.
export const logDev = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
